// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import Plan from '../views/PlanView.vue';
import Me from '../views/MeView.vue';
import Confirm from '../views/ConfirmView.vue';
import Main from '../views/MainView.vue';
import LuckyWheel from '@/views/LuckyWheel.vue';
import ShareCarousel from '@/views/ShareCarousel.vue';
// import Disabled from '../views/DisabledView.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/content/:type',
    name: 'Content',
    component: Home
  },
  {
    path: '/plan',
    name: 'Plan',
    component: Plan
  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: Confirm
  },
  // {
  //   path: '/disabled',
  //   name: 'Disabled',
  //   component: Disabled
  // },
  {
    path: '/me',
    name: 'Me',
    component: Me
  },
  {
    path: '/main',
    name: 'Main',
    component: Main
  },
  {
    path: '/luckywheel',
    name: 'LuckyWheel',
    component: LuckyWheel
  },
  {
    path: '/share_management',
    name: 'ShareCarousel',
    component: ShareCarousel
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
